export default __webpack_public_path__ + "static/media/thop-aparelho-invisivel.f23f16ec.png";